import { displayContent } from 'modules/templateEditor/common/content';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { PageHeaderInlineEdit } from 'ui/inlineEdit';

import { addNegativeToastWithErrorId, addPositiveToast } from 'modules/toastContainer';
import { useEditCampaignNameMutation } from 'modules/campaigns/lib';
import { useCampaignContext } from '../../context';

export const CampaignName = () => {
  const {
    campaign: { id, name: initialName },
    refetch: refetchCampaign,
  } = useCampaignContext();

  const dispatch = useDispatch();

  const [campaignName, setCampaignName] = useState(initialName);

  const { mutate } = useEditCampaignNameMutation({
    onError(error) {
      const errorMessage = displayContent.errUpdateCampaignName;
      dispatch(addNegativeToastWithErrorId(errorMessage, 'CampaignName', error));
    },
    onSuccess() {
      const message = displayContent.strDataUpdatedSuccessfully({ dataName: campaignName });
      dispatch(addPositiveToast(message));
      refetchCampaign();
    },
  });

  const handleBlur = () => {
    if (campaignName !== initialName) {
      mutate({ campaignId: id, name: campaignName });
    }
  };

  return (
    <PageHeaderInlineEdit
      showTooltipWhenOverflow
      onBlur={handleBlur}
      onChange={setCampaignName}
      value={campaignName}
    />
  );
};
